import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';
import React from 'react';
import { Outlet } from 'react-router-dom';

import AdminPage from './app/admin/page';
import AgentDetailsPage from './app/agents/details/page';
import AgentEditPage from './app/agents/edit/page';
import AgentsPage from './app/agents/page';
import AgentPlaygroundPage from './app/agents/playground/page';
import AuditPage from './app/audit/page';
import CreateContractPage from './app/dataCatalog/create/page';
import DataContractDetailsPage from './app/dataCatalog/details/page';
import DataExplorerPage from './app/dataCatalog/explorer/page';
import DataCatalogPage from './app/dataCatalog/page';
import EvaluationsComparePage from './app/evaluations/compare/page';
import EvaluationsMetricPage from './app/evaluations/metric/page';
import EvaluationsMetricsPage from './app/evaluations/metrics/page';
import EvaluationsPage from './app/evaluations/page';
import EvaluationsResultsPage from './app/evaluations/results/page';
import EvaluationsRunsPage from './app/evaluations/runs/page';
import EvaluationsSourcePage from './app/evaluations/source/page';
import EvaluationsSourcesPage from './app/evaluations/sources/page';
import RootLayout from './app/layout';
import LoginCallbackPage from './app/login/callback/page';
import LoginPage from './app/login/page';
import LogsPage from './app/logs/page';
import ModelDetailsPage from './app/models/details/page';
import ModelsPage from './app/models/page';
import ModelPlaygroundPage from './app/models/playground/page';
import NotFoundPage from './app/not-found';
// Page components
import HomePage from './app/page';
import PromptCreatePage from './app/prompts/create/page';
import PromptsPage from './app/prompts/page';
import SettingsPage from './app/settings/page';
import { ProtectedRoute } from './components/RouteGuards';
import envVarsProvider from './utils/envVars/envVars';

const router = createBrowserRouter( [
  {
    element: <RootLayout><Outlet /></RootLayout>,
    errorElement: <NotFoundPage />,
    children: [
      // Protected routes
      { path: '/', element: <ProtectedRoute><HomePage /></ProtectedRoute> },
      { path: '/admin', element: <ProtectedRoute><AdminPage /></ProtectedRoute> },
      { path: '/audit', element: <ProtectedRoute><AuditPage /></ProtectedRoute> },
      { path: '/agents', element: <ProtectedRoute><AgentsPage /></ProtectedRoute> },
      { path: '/agents/details', element: <ProtectedRoute><AgentDetailsPage /></ProtectedRoute> },
      { path: '/agents/edit', element: <ProtectedRoute><AgentEditPage /></ProtectedRoute> },
      { path: '/agents/playground', element: <ProtectedRoute><AgentPlaygroundPage /></ProtectedRoute> },
      { path: '/models', element: <ProtectedRoute><ModelsPage /></ProtectedRoute> },
      { path: '/models/details', element: <ProtectedRoute><ModelDetailsPage /></ProtectedRoute> },
      { path: '/models/playground', element: <ProtectedRoute><ModelPlaygroundPage /></ProtectedRoute> },
      { path: '/prompts', element: <ProtectedRoute><PromptsPage /></ProtectedRoute> },
      { path: '/prompts/create', element: <ProtectedRoute><PromptCreatePage /></ProtectedRoute> },
      { path: '/evaluations', element: <ProtectedRoute><EvaluationsPage /></ProtectedRoute> },
      { path: '/evaluations/compare', element: <ProtectedRoute><EvaluationsComparePage /></ProtectedRoute> },
      { path: '/evaluations/metric', element: <ProtectedRoute><EvaluationsMetricPage /></ProtectedRoute> },
      { path: '/evaluations/metrics', element: <ProtectedRoute><EvaluationsMetricsPage /></ProtectedRoute> },
      { path: '/evaluations/results', element: <ProtectedRoute><EvaluationsResultsPage /></ProtectedRoute> },
      { path: '/evaluations/runs', element: <ProtectedRoute><EvaluationsRunsPage /></ProtectedRoute> },
      { path: '/evaluations/source', element: <ProtectedRoute><EvaluationsSourcePage /></ProtectedRoute> },
      { path: '/evaluations/sources', element: <ProtectedRoute><EvaluationsSourcesPage /></ProtectedRoute> },
      { path: '/logs', element: <ProtectedRoute><LogsPage /></ProtectedRoute> },
      { path: '/settings', element: <ProtectedRoute><SettingsPage /></ProtectedRoute> },
      { path: '/dataCatalog', element: <ProtectedRoute><DataCatalogPage /></ProtectedRoute> },
      { path: '/dataCatalog/details', element: <ProtectedRoute><DataContractDetailsPage /></ProtectedRoute> },
      { path: '/dataCatalog/create', element: <ProtectedRoute><CreateContractPage /></ProtectedRoute> },
      { path: '/dataCatalog/explorer', element: <ProtectedRoute><DataExplorerPage /></ProtectedRoute> },

      // Login routes (accessible regardless of auth status)
      { path: '/login', element: <LoginPage /> },
      { path: '/login/callback', element: <LoginCallbackPage /> }
    ]
  }
], {
  basename: envVarsProvider.get( 'STUDIO_BASE_PATH' ) || '/'
} );

export default router;
